import React, { useEffect, useState } from 'react'
import styles from './PinMessageHeader.module.scss'
import { ReactComponent as AllPinMessageIcon } from 'components/CRM/UI/icons/all-pin-message.svg'
import { ReactComponent as PinIcon } from 'components/CRM/UI/icons/pushpin-line.svg'
import { ReactComponent as ArrowRightIcon } from 'components/UI/icons/arrow-right-line.svg'
import useLocalization from 'hooks/useLocalization'

const PinMessageHeader = ({
  pinPage,
  setPinPage,
  fetchMessages,
  pinnedMessages,
  scrollToMessage,
  setShouldScroll,
}) => {
  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      today: 'Today',
      yesterday: 'Yesterday',
      pinned_message: 'Pinned message',
      pinned_task: 'Pinned task',
    },
  })

  const [currentMessageIndex, setCurrentMessageIndex] = useState(
    pinnedMessages?.length - 1,
  )
  const [currentDate, setCurrentDate] = useState(null)

  useEffect(() => {
    if (pinnedMessages.length > 0) {
      setCurrentMessageIndex(pinnedMessages.length - 1)
    }
  }, [pinnedMessages])

  const getMessageText = (message) => {
    if (message?.type === 'message') {
      if (message?.data?.text) {
        return message.data.text.length > 30
          ? `${message.data.text.slice(0, 30)}...`
          : message.data.text
      } else if (message?.data?.file) {
        const fileName = message.data.file.file.split('/').pop()
        return fileName.length > 30 ? `${fileName.slice(0, 30)}...` : fileName
      }
    } else if (message?.type === 'task') {
      return message.data?.title?.length > 30
        ? `${message.data.title.slice(0, 30)}...`
        : message.data.title
    }
    return ''
  }

  const pinMessage =
    pinnedMessages && pinnedMessages.length > 0
      ? pinnedMessages[currentMessageIndex]
      : null
  const pinnedMessageText = pinMessage ? getMessageText(pinMessage) : ''

  const handlePinMessageClick = () => {
    if (currentMessageIndex > 0) {
      setCurrentMessageIndex(currentMessageIndex - 1)
    } else if (pinnedMessages && pinnedMessages.length > 0) {
      setCurrentMessageIndex(pinnedMessages.length - 1)
    }
    scrollToMessage(pinMessage.data.id) // Вызов функции прокрутки
  }

  useEffect(() => {
    let date = null
    if (pinnedMessages[currentMessageIndex]?.type === 'message') {
      date = new Date(pinnedMessages[currentMessageIndex]?.data?.sent_at)
    } else if (pinnedMessages[currentMessageIndex]?.type === 'task') {
      date = new Date(pinnedMessages[currentMessageIndex]?.data?.created_at)
    }

    setCurrentDate(date)
  }, [pinnedMessages, currentMessageIndex])

  const returnCurrentData = () => {
    if (!currentDate) {
      return ''
    }

    const today = new Date()
    const yesterday = new Date(today.getTime() - 86400000)

    today.setHours(0, 0, 0, 0)
    yesterday.setHours(0, 0, 0, 0)

    if (currentDate >= today) {
      return `${translate.today} ${currentDate.toLocaleTimeString()}`
    } else if (currentDate >= yesterday) {
      return `${translate.yesterday} ${currentDate.toLocaleTimeString()}`
    } else {
      return `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`
    }
  }

  return (
    <div className={styles.pinMessageContainer}>
      <div className={styles.pinMessageWrapper}>
        {pinPage && (
          <ArrowRightIcon
            onClick={() => {
              setPinPage(false)
              setShouldScroll(true)
              fetchMessages()
            }}
            className={styles.arrowIcon}
          />
        )}
        <PinIcon />
        <div className={styles.pinMassageBlock}>
          {pinPage ? (
            <div className={styles.pinMassage}>
              {pinnedMessages?.length} {translate.pinned_message}
            </div>
          ) : (
            <div onClick={handlePinMessageClick} className={styles.pointer}>
              <div className={styles.pinMassage}>
                {pinMessage?.type === 'task'
                  ? `${translate.pinned_task}`
                  : `${translate.pinned_message}`}{' '}
                "{pinnedMessageText}"
              </div>
              <div className={styles.pinData}>{returnCurrentData()}</div>
            </div>
          )}
        </div>
      </div>
      <AllPinMessageIcon
        className={styles.allPinIcon}
        onClick={() => {
          setPinPage(true)
          fetchMessages()
        }}
      />
    </div>
  )
}

export default PinMessageHeader
